import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="checklists" pageTitle="检查清单" pageDescription="面向制药、生物技术、医疗器械和 IVD 的法规、质量与验证项目的实用合规检查清单。" showAssessments />;

export const Route = createFileRoute("/zh-cn/downloads/checklists/")({
  head: () => buildRouteHead("/zh-cn/downloads/checklists", {
    title: "生命科学合规检查清单 | QbD Group",
    description: "下载由 QbD Group 专家编写的 MDR、ISO 13485、21 CFR Part 11、Annex 11 等合规检查清单。",
  }),
  component: ContentListingRoute,
});
